import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: ['fr', 'en'],
    messages: {
        fr: {
            welcome: ' Bienvenue sur ',
            home_text: 'E-visa est une plateforme pour la demande, la gestion et le traitement des dossiers de demande de visas en ligne pour le compte de la République du Cameroun ! Pour faire votre demande de visa, vous êtes priés de suivre les étapes mentionnées dans le guide pratique. ',
            sign_in: ' Se connecter ',
            sign_up: " S'inscrire ",
            text1: ' Connectez-vous à votre compte ou créez-en un ',
            text2: ' Remplissez et soumettez le formulaire de demande ',
            text3: '  Payez les frais de services  ',
            ask_demand: ' Faire une demande ',
            login_title: ' Connectez vous ',
            register_title: ' Inscrivez vous ',
            login_btn: ' Se Connecter ',
            register_btn: " S'inscrire ",
            not_member: ' Pas encore inscrit? ',
            not_member: ' Pas encore inscrit? ',
            ticket_title: ' Mes demandes d\'assistance ',
            contact_title: ' Contactez Nous ',
            contact_btn: ' Envoyer ',
            contact_clear: ' Effacer ',
            next_btn: ' Suivant ',
            return_btn: ' Retour ',
            ask_title: ' Veuillez suivre les étapes suivantes pour faire une demande de visa ',
            ask_btn: ' Nouvelle demande ',
            ask_ticket: ' Créer une demande d\'assistance ',
            personal_info: ' Information Personnelles ',
            visa_info: ' Informations Visa  ',
            piecesjointes: ' Pièces jointes ',
            country: ' Pays ',
            close_btn: ' Fermer ',
            valide_btn: ' Enregistrer ',
            start_country: ' Pays de départ ',
            ask_notif: ' Demande envoyée avec succès, veuillez attendre pour approbation.Vous pourvez vérifier le statut de la demande sur la page suivante ',
            embassade: ' Embassade ',
            statut: ' Statut ',
            search_text: ' Rechercher ',
            valid: ' Validé ',
            progress: ' En cours ',
            rejecte: ' Rejetées ',
            firstName: ' Prénom ',
            lastName: ' Nom ',
            gender: ' Genre ',
            birthday: ' Date de Naissance ',
            home_country: " Pays d'origine de la demande",
            visa_type: ' Type de Visa ',
            travel_reason: ' Motif de voyage ',
            mission_order: ' Ordre de Mission ',
            nationality: ' Nationalité ',
            expiredate: " Date d'expiration du passeport ",
            passport: ' Passeport',
            passport_number: ' Numero de Passeport ',
            copypassport: ' Copie du passeport ',
            password: ' Mot de passe ',
            password_confirm: ' Confirmation de Mot de passe ',
            minCaracter: ' Au  moins 8 characters ',
            required_email: " L'email est obligatoire ",
            valid_email: ' Veuillez entrer un email valide ',
            required_password: ' Le Mot de Passe est obligatoire ',
            min_password: ' Votre mot de passe doit avoir au moins 8 characters ',
            required_firstname: ' Votre prénom est obligatoire ',
            required_lastname: ' Votre Nom est obligatoire ',
            required_confirm_password: ' Mot de passe non confirmé ',
            required_confirm_email: ' Email non confirmé ',
            match_password: ' Mot de passe non conforme ',
            match_email: ' Email non conforme ',
            fullname: ' Nom et Prénom ',
            codeDemand: ' Code de la demande ',
            required_fullname: ' Nom et Prénom obligatoire ',
            required_codeDemand: ' Code de la demande obligatoire ',
            max_fullname: ' Votre nom doit avoir au plus 30 characters  ',
            comment: ' Commentaire ',
            required_comment: ' Le Commentaire obligatoire ',
            home: ' Acceuil ',
            dashboard: ' Mes demandes ',
            rdv: ' Mes rendez-vous ',
            ticket: ' Créer un ticket ',
            valider: ' Valider ',
            password_error: ' Veuillez bien renseigner vos identifiants de connexion',
            credentiel: ' Veuillez bien renseigner vos identifiants de connexion',
            email_error: ' Cet adresse email est déjà utilisé ',
            confirm_email_error: ' Veuillez confirmer votre email pour accéder à votre compte ',
            connexion_error: " Asurez vous d'être connecté à internet ",

            required_gender: '  Veuillez renseigner votre genre ',
            required_birthdate: '  Veuillez renseigner votre date de naissance ',
            required_homecountry: ' Votre pays de naissance est obligatoire ',
            required_birthcountry: ' Votre pays de naissance est obligatoire',
            required_current_nationality: ' Votre nationalité actuelle est obligatoire ',
            required_origine_nationality: " Votre nationalité d'origine est obligatoire ",
            required_motif: ' Votre motif de voyage est obligatoire ',
            required_ordremission: ' Votre ordre de mission est obligatoire ',
            required_visatype: ' Votre type de visa est obligatoire ',
            required_nationality: ' Votre nationalité est obligatoire ',
            required_expiredate: "  Veuillez renseigner la date d'expiration de votre passeport ",
            required_passportnumber: ' Veuillez renseigner le numéro de votre passeport ',
            min_passportnumber: ' Votre numéro de passeport doit contenir au moins 06 caractères ',
            max_passportnumber: ' Votre numéro de passeport doit contenir au plus 09 caractères ',
            caracter_passportnumber: ' Votre numéro de passeport ne doit contenir que des lettres et chiffres ',
            min_motif: " Votre motif doit être d'au moins 10 caractères ",
            min_ordremission: " Votre ordre de mission doit être d'au moins 10 caractères ",
            required_copypassport: ' Votre copie de passeport est obligatoire ',
            required_justificatiflogement: " Votre Réservation d'hotel/ Lettre d'invitation est obligatoire ",
            justificatiflogement: " Réservation d'hotel/ Lettre d'invitation ",
            pay_btn: ' Payer ',
            list_demand_title: ' Listes des demandes ',
            file_required: ' Veuillez charger que des fichiers de type : jpeg, jpg, svg ',
            required_phonenumber: '  Votre numero de téléphone est obligatoire ',
            welcome_word: ' Bienvenue sur evisa Cameroun ',
            email_notif: ' Votre mail a bien été envoyé ',
            en_cours: ' En cours ',
            approuve: ' Validées ',
            phonenumber: 'Téléphone',
            all: ' Toutes ',
            visa_court_sejour: 'Visa de court séjour',
            visa_travail: 'Visa de travail',
            visa_transit: 'Visa de transit',
            affaire_visa: "Visa d'affaire",
            temporary_visa: 'Visa temporaire',
            long_visa: 'Visa long séjour',
            tourist_visa: 'Visa de tourisme',
            number_day: 'Nombre de jour',

            confirm_count_text: ' Bienvenue sur la plateforme e-visa Cameroun. Pour accéder à votre compte, veuillez confirmer votre email. Consultez vos mails et cliquer sur le lien de confirmation de compte. ',
            payment_confirm: ' Paiment Confirmé ',
            payment_pending: ' Paiement en cours de validation ',
            success_demand: ' Votre demande est bien reçue ',
            click_link: ' Cliquez sur le lien ci-dessous pour voir les demandes. ',
            requests: 'Mes demandes ',
            caracter_firstname: 'Le champ prénom ne doit pas contenir de carateres spéciaux',
            caracter_lastname: ' Le champ nom ne doit pas contenir de carateres spéciaux',
            faq: ' Foire à question ',
            logout: 'Déconnexion',
            reject: 'Rejetées',
            help_upload: '- Veuillez charger à nouveau la photo de votre passeport et du justificatif de votre logement',
            delivert_at: 'Délivrée à/au',
            valide_from: 'Valide de ',
            valide_to: "Jusqu'au",
            reject_raison: 'Raison du rejet',
            snackbar_update_ok: ' Mise à jour bien éffectuée ',
            snackbar_update_no: " Il s'est produit une erreur ",
            Cameroun_republic: ' REPUBLIQUE DU Cameroun ',
            guide_title: 'Guide pratique de demande du Visa camrounais',
            inscription: 'Inscription',
            inscription_p1: "Remplir le formulaire d’enrôlement avec toutes les informations requises pour vous inscrire sur la plateforme E-visa Cameroun Pour compléter le formulaire, vous aurez besoin d'un",
            inscription_p2: "Pour compléter le formulaire, vous aurez besoin d'un",
            inscription_p3: 'A la fin de votre inscription un lien de confirmation sera envoyé dans votre boîte mail sur lequel vous devez cliquer pour activer votre compte',
            inscription_s: 'Mot de passe de huit(08) caractère au moins',
            request: 'Demande de visa',
            request_t: 'Après votre inscription pour faire votre demande de visa vous devez:',
            request_li1: 'Vous Connecter avec votre adresse mail et le mot de passe que vous avez choisi.',
            request_li2: "Cliquer sur l'onglet <<Nouvelle demande>> puis suivre les quatre (04) étapes de la demande.",
            request_step1: 'Première étape: les informations personelles',
            request_step2: 'Deuxième étape:la demande de visa',
            request_step3: 'Troisième étape :les pièces jointes',
            request_step4: 'Le paiement',
            request_step1_d: "Renseignez vos informations personelles y compris le <<pays d'origine>> qui est le pays dans lequel vous résidez actuellement",
            request_step2_d: 'Renseignez les informations liées à votre demande de visa y compris le <<type de visa>>',
            request_step3_d: "Ajoutez les documents nécéssaires à votre <<demande de visa>> dont votre passeport ayant une validité d'au moins six(06) mois et votre justificatif de logement au Cameroun",
            request_step4_d: 'Il vous sera demandé de cliquer sur le boutton Payer pour payer les frais liés à la demande de votre visa.',
            request_step4_d1: 'A cette étape, vous pouvez laissez le paiement et le refaire plus tard en cliquant sur le boutton payer dans la colonne status de paiement en consultant cette demande dans le tableau des demandes.',
            recap: 'Recapitulatif',
            recap_d: "Il s'agit d'un resumé des informations renseignées et une prévisualisation des documents que vous avez ajouter.",
            treatment: 'Le traitement de la demande',
            treatment_t: "Après la soumission de votre requête de demande de visa, votre demande entre dans la file d'attente et à chaque étape de traitement, un mail vous sera envoyé et vous pouriez consulter en temps réel les <<status de votre demande>> et son evolution qui se resume comme suite:",
            treatment_l1: 'Premier niveau:votre demande est encore en attente',
            treatment_l2: 'Deuxieme niveau:Votre demande faire objet de vérification',
            treatment_l3: 'Troisieme niveau: le rendez-vous',
            treatment_d: "c'est seulement à cete étape que vous pouriez faire des modifications de votre demande si vous avez d'eventuelles corrections à faire.",
            treatment_l2_d: 'A la fin de la verifiation un nouveau mail vous sera envoyé et vous verez le status de votre demande après verification.',
            treatment_l3_d: 'A cette etape vous êtes invité à vous rendre selon votre pays dans une ambassade ,un consulat ou un poste frontalier spécifique pour des vérifications physique.',
            to_know: 'A savoir',
            to_know_t: 'Si la demande de votre status est:',
            pending: 'Si la demande de votre status est:',
            complement: "c'est que votre demande néccéssite un complement d'information que vous devez faire en cliquant qur l'icom de modification",
            rejet: "est que votre demande est rejectée et vous pouriez voir la raison en cliquant sur l'icon d'oeil",
            valide: "c'est que votre demande est traitée et que vous pourriez à la suite, prendre votre visa",
            get_psp: 'La réception de votre visa',
            get_psp_d_presentiel: 'Validation présentiel',
            get_psp_d: 'Vous devez vous rendre au poste de traitement indiqué pour recevoir votre visa.',
            file_complement: ' Fichier du complément',
            valid_caracter: ' Au moins 8 caratères, une lettre majuscule et un chiffre pour le mot de passe ',
            btn_reset: ' Actualiser ',
            save_btn: ' Enregister ',
            no_data: 'Acune données trouvées',
            agree: "Acceptez-vous les ",
            required_checkbox: " Veuillez confirmer que vous accepetez les conditions d'utilisations",
            reset_title: 'Modifier votre mot de passe',
            new_password: 'Nouveau mot de passe',
            askemail_title: 'Veuillez entrez votre email pour réinitilaiser votre mot de passe',
            reset_btn: ' Rénitialiser',
            pwdforget_btn: 'Mot de passe oublié ?',
            checkmail_success: ' Email vérifié, Veuillez consulter votre mail pour réinitialiser votre mot de passe ',
            checkmail_failed: ' Email non vérifié',
            updatepwd_failed: ' Mise à jour de mot de passe non éffectuée',
            updatepwd_success: ' Mise à jour de mot de passe bien éffectué',
            btn_show: 'Voir ',
            birthcountry: "Pays de naissance",
            birthplace: "Lieu de naissance",
            required_birthplace: " Votre lieu de naissance est obligatoire",
            current_nationality: "Nationalité actuelle",
            origine_nationality: "Nationalité d'origine",
            marital_status: "Situation matrimoniale",
            required_marital_status: "Votre situation matrimoniale est obligatoire",
            postal_code: "Code Postal",
            town: "Ville",
            work: "Profession",
            adresse: " Adresse géographique",
            required_adresse: "Votre adresse géographique est obligatoire",
            required_codepostal: "Votre code postal est obligatoire",
            required_town: "Votre ville est obligatoire",
            required_work: " Votre profession est obligatoire",
            delivercountry: " Pays de délivrance ",
            required_delivercountry: " Votre pays de délivrance est obligatoire",
            deliverdate: " Date de délivrance ",
            required_deliverdate: " Votre date de délivrance est obligatoire",
            acreditationcounrty: " Lieu d'obtention de visa",
            required_acreditationcounrty: " Le lieu d'obtention de visa est obligatoire",
            startdate: " Date de départ du séjour",
            enddate: " Date de fin du séjour",
            required_startdate: " Date de départ du séjour",
            required_enddate: " Date de fin du séjour",
            flugticket: " Ticket d'avion",
            required_flugticket: " Ticket d'avion",
            contactname: " Nom et prenom de votre contact",
            contactemail: " Email de votre contact",
            contacttown: " Ville de votre contact",
            contactadresse: " Adresse de votre contact",
            required_contactname: " Le nom et  le prenom de votre contact est obligatoire",
            required_contactemail: " L' email de votre contact est obligatoire",
            required_contacttown: " La ville de votre contact est obligatoire",
            required_contactadresse: " L'adresse de votre contact est obligatorie",
            demand_contact_title: "Nom et adresse de votre contact d'affaire",
            familly_title: " Famille au cameroun",
            has_familly: "Avez vous de la famille au cameroun",
            residence_title: " Lieu de résidence au cameroun",
            yes: "Oui",
            no: "Non",
            residencename: " Nom de la  residence",
            residenceemail: " Email de la residence",
            residencetown: " Ville de la residence",
            residenceadresse: " Adresse de la residence",
            required_residencename: " Le nom de la residence est obligatoire",
            required_residenceemail: " L' email de la residence est obligatoire",
            required_residencetown: " La ville de la residence est obligatoire",
            required_residenceadresse: " L'adresse de la residence est obligatorie",

            famillyname: " Nom de la  famille",
            famillyemail: " Email de la famille",
            famillytown: " Ville de la famille",
            famillyadresse: " Adresse de la famille",
            required_famillyname: " Le nom de la famille est obligatoire",
            required_famillyemail: " L' email de la famille est obligatoire",
            required_famillytown: " La ville de la famille est obligatoire",
            required_famillyadresse: " L'adresse de la famille est obligatorie",
            security_title: " Vous vous engagez à n'accepter aucune proposition d 'emploi durant votre séjour au Cameroun, de ne pas tenter de rester en permanence et d 'avoir quitté le pays a la date d 'expiration de votre visa? ",
            addinfo: "Information additionnelles",
            travel_info: "Information de voyages",
            stay_info: "Informations de séjour",
            paiement: "Paiement",
            to_marry: "Marié",
            veuve: "Veuve",
            celibataire: "Célibataire",
            celi_nokid: "Célibataire sans enfant",
            celi_withkid: "Célibataire avec enfant",
            cam_residence: "Lieu de résidence au cameroun",
            no_demande: "Vous ne pouvez pas prendre rendez-vous",
            wait_rdv: "Mes demandes en attentes de Rendez-vous",
            take_rdv: "Prenez un rendez vous",
            rdv_at: "Rendez vous en cours pour",
            requet_rdv: "Veuillez demander un rendez vous en entrant les champs suivants",
            date_rdv: "Date du rendz vous",
            heur_dispo: "Heure Diponible",
            no_date: "Date Indisponible",
            no_rdv: "Pas de rendez-vous possible pour cette date et cette heure",
            takesucess_rdv: "Rendez vous pris avec succès",
            place_rdv: "Lieu de rendez vous",
            date_require: "Date obligatoire",
            time_require: "Heure obligatoire",
            ticket_wait: "Nous avion pris en compte votre requête. Une équipe vous prendra en charge dans quelques insatants. Veuillez vérifier votre boite adresse(Email)",
            ticket_alredy: "Vous avez déjà une requête d'assistance encours pour cette demande. Nos équipes vous reviendra sous peu. Vous pouvez aussi cloturer pour en creé d'autre. Merci !",
            code_not_found: "Nous avons du mal à retrouver votre code",
            erreur_produit: "Une erreure s'est produite",
            complement_info: "    Ceci est un complément d'information pour raison de :",
            rejet_info: " Ceci est un rejet pour raison de :",
            demand_information: "Information de la demande",
            data: "Données",
            file: "Fichiers",

        },
        en: {
            data: "Data",
            file: "Files",
            demand_information: "Demand information",

            reject_info: " This is a reject due to :",
            complement_info: "  This is additional information for reasons of : ",
            erreur_produit: "An error has occurred",
            code_not_found: "We have trouble finding your code",
            ticket_alredy: "You already have an outstanding support request for this application. Our team will get back to you shortly. You can also close to create new ones. Thank you!",
            ticket_wait: "We have taken into account your request. A team will take care of you in a few minutes. Please check your mailbox (Email)",
            time_require: "Date required",
            date_require: "Time required",
            place_rdv: "Meeting place",
            place_rdv: "Meeting place",
            takesucess_rdv: "Appointment made with success",
            no_rdv: "No appointment possible for this date and time",
            no_date: "Date Unavailable",
            heur_dispo: "Diponible Time",
            date_rdv: "Date of appointment",
            requet_rdv: "Please request an appointment by entering the following fields",

            rdv_at: "Appointment in progress for",

            take_rdv: "Make an appointment",
            wait_rdv: "My requests for an appointment",
            no_demande: "No applications validated",
            cam_residence: "Place of residence in Cameroon",
            celi_withkid: "Single with child",
            celi_nokid: "Single without children",
            celibataire: "Single",
            veuve: "Widow",
            to_marry: "Married",
            paiement: "Payment",
            stay_info: "Information about your stay",
            travel_info: "Travel Information",

            addinfo: "Additional information",
            security_title: "You agree not to accept any job offer during your stay in Cameroon, not to try to stay permanently and to have left the country by the expiration date of your visa? ",

            famillyname: "Familly name",
            famillyemail: " Familly email",
            famillytown: " Familly town",
            famillyadresse: "  Familly adresse",
            required_famillyname: " Familly name is required",
            required_famillyemail: " Familly email is required",
            required_famillytown: " Familly town is required",
            required_famillyadresse: " Familly adresse is required",

            residencename: " Residence name",
            residenceemail: " Residence email",
            residencetown: " Residence town",
            residenceadresse: " Residence adresse",
            required_residencename: " Residence name is required ",
            required_residenceemail: " Residence email is required",
            required_residencetown: "Residence town is required",
            required_residenceadresse: " Residence adresse is required ",
            yes: "Yes",
            no: "No",
            residence_title: " Place of residence in Cameroon",
            has_familly: "Do you have familly at cameroun",
            demand_contact_title: " Name and address of your business contact",
            familly_title: "  Cameroun familly",
            contactname: " Your contact name ",
            contactemail: " Your contact email  ",
            contacttown: "Your contact town ",
            contactadresse: " Your contact adress ",

            required_contactname: " Your contact name is required",
            required_contactemail: "Your contact email is required ",
            required_contacttown: " Your contact town is required",
            required_contactadresse: " Your contact adress is required",

            flugticket: " Flug ticket",
            required_flugticket: " Flug ticket is required",
            startdate: " Start date of the stay",
            enddate: " End date of the stay",
            required_startdate: " Start date of the stay is required",
            required_enddate: " End date of the stay is required",
            acreditationcounrty: " Place of obtaining the visa ",
            required_acreditationcounrty: " Place of obtaining the visa is required",
            deliverdate: " Deliver date ",
            required_deliverdate: " Your deliver date is required",
            delivercountry: " Deliver country ",
            required_delivercountry: " Your country deliver is required",
            required_work: " Your work is required",
            required_adresse: " Your geographic adresse is required",
            required_birthplace: " Your birthplace is required",
            adresse: "Geographic address",
            work: "Work",
            postal_code: "Postal code",
            required_codepostal: "Your postal code is required",
            town: "Town",
            required_town: "Your town is required",
            marital_status: "Marital status",
            required_marital_status: "Your marital status is required",

            origine_nationality: "Nationality of origin",
            current_nationality: "Current nationality",
            birthplace: "Place of birth",
            birthcountry: "Birth Country",
            required_nbrdays: ' The number of days for your travel is required',
            sejoursdays: 'Number of days for your travel',
            btn_show: 'Show ',
            updatepwd_failed: ' Password pdate failed',
            updatepwd_success: ' Password updated successfully',
            agree: ' Do you accept the ',
            checkmail_failed: ' Email not verified',
            checkmail_success: ' Email verify successfully, Please check your mail to reset your password',
            pwdforget_btn: 'Password forgotten',
            reset_btn: ' Reset password',
            askemail_title: 'Your email for password reset is required',
            save_btn: ' Save ',
            reset_title: 'Change your password',
            new_password: 'New password',
            no_data: 'No data found ',
            required_checkbox: ' Please confirm that you agree with our terms conditions',
            file_complement: 'Complement file',
            valid_caracter: '  At least 8 characters, one capital letter and one number for the password ',
            guide_title: 'Practical guide to applying for a Cameroon Visa',
            inscription: 'Register',
            inscription_p1: 'Complete the enrollment form with all the information required to register on the E-visa Cameroon platform',
            inscription_p2: 'To complete the form, you will need a',
            inscription_p3: 'At the end of your registration a confirmation link will be sent to your email account on which you must click to activate your account',
            inscription_s: 'Password of at least eight (08) characters',
            request: 'Applying for your first visa',
            request_t: 'After registering to apply for your visa you must:',
            request_li1: 'Log in with your email address and the password you have chosen.',
            request_li2: 'Click on the <<New Request>> tab and follow the four (4) steps of the request.',
            request_step1: 'First step: personal information',
            request_step2: 'Second step: the visa application',
            request_step3: 'Step 3: Attachments',
            request_step4: 'Fourth step: payment',
            request_step1_d: 'Fill in your personal information including the <<country of origin>> which is the country in which you currently reside',
            request_step2_d: 'Fill in the information related to your visa application including the <<type of visa>>',
            request_step3_d: 'Add the necessary documents to <<your visa>> application including your passport with a validity of at least six (06) months and your proof of accommodation in Cameroon',
            request_step4_d: 'You will be asked to click on the Pay button to pay your visa application fee.',
            request_step4_d1: 'At this stage, you can leave the payment and do it again later by clicking on the pay button in the payment status column when viewing this request in the request table.',
            recap: 'Summary',
            recap_d: 'This is a summary of the information you have entered and a preview of the documents you have added.',
            treatment: 'Processing the request',
            treatment_t: 'After submitting your visa application, your application will enter the queue and at each stage of processing, an email will be sent to you and you will be able to consult in real time the <<status of your application>> and its progress as follows',
            treatment_l1: 'First level: your request is still pending',
            treatment_l2: 'Second level: Your request is subject to verification',
            treatment_l3: 'Third level: the appointment',

            treatment_d: 'it is only at this stage that you can make changes to your application if you have any corrections to make.',
            treatment_l2_d: 'At the end of the verification a new email will be sent to you and you will see the status of your request after verification.',
            treatment_l3_d: 'At this stage you are invited to go to a specific embassy, consulate or border post depending on your country for physical verification.',
            to_know: 'To know more',
            to_know_t: 'If your status request is:',
            pending: 'is that your request is being processed',
            complement: 'is that your request requires additional information that you must do by clicking on the modification icon',
            rejet: 'is that your application is rejected and you could see the reason by clicking on the eye icon',
            valide: 'is that your application is processed and that you can then take your visa',
            get_psp: 'Receipt of your visa',
            get_psp_d: 'You must go to the designated processing station to receive your visa.',
            get_psp_d_presentiel: 'Face-to-face validation',

            Cameroun_republic: ' REPUBLIC OF CAMEROON ',
            snackbar_update_ok: ' Update well done ',
            snackbar_update_no: ' An error has occurred ',
            help_upload: '- Please upload again your passport file and proof of accommodation file',
            reject: 'Rejeted',
            welcome: 'Welcome on',
            home_text: ' E-visa is a platform for the application, management and processing of visa applications online on behalf of the Republic of Cameroon! ',
            sign_in: ' Sign in ',
            sign_up: ' Sign up ',
            text1: ' Log in to your account or create one ',
            text2: ' Complete and submit the application form ',
            text3: ' Pay for services  ',
            ask_demand: ' Make a request ',
            login_title: ' Sign In ',
            register_title: ' Sign Up ',
            login_btn: ' Sign In ',
            register_btn: ' Sign Up ',
            not_member: ' Not yet a member? ',
            ticket_title: ' My support requests ',
            contact_title: ' Contact Us ',
            contact_btn: ' Send ',
            contact_clear: ' Clear ',
            next_btn: ' Next ',
            return_btn: ' Return ',
            ask_title: ' Please follow these steps to apply for a visa ',
            personal_info: ' Personals Informations ',
            visa_info: ' Visa Informations ',
            piecesjointes: ' Attachments ',
            ask_btn: ' Ask for Visa ',
            ask_ticket: ' Create a support request ',
            close_btn: ' Close ',
            valide_btn: ' Save ',
            start_country: ' Country of departure ',
            ask_notif: ' Application sent successfully, please wait for approval. you can check the status of the application on the following page ',
            embassade: ' Embassy ',
            statut: ' Status ',
            search_text: ' Search ',
            valid: 'Valided',
            progress: ' In progress ',
            rejecte: ' Rejected ',
            firstName: ' First Name ',
            lastName: ' Name ',
            country: ' Country ',
            gender: ' Gender ',
            birthday: ' BirthDay ',
            home_country: ' Country of origin of the request ',
            visa_type: ' Type of Visa ',
            travel_reason: ' Reason for Travel ',
            mission_order: ' Mission Order ',
            nationality: ' Nationality ',
            expiredate: ' Expiration Date ',
            passport: ' Passport',
            passport_number: ' PassPort Number ',
            copypassport: ' Passport copy',
            password: ' Password ',
            password_confirm: ' Password Confirmation ',
            minCaracter: ' At least 8 characters ',
            required_email: ' Email is required ',
            valid_email: ' Enter valid mail ',
            required_password: ' Password is required ',
            min_password: ' Your password must be at least 8 characters long ',
            required_confirm_password: ' Password confirmation required ',
            required_confirm_email: ' Email confirmation required ',
            match_password: ' Password not match ',
            match_email: ' Email not match ',
            fullname: ' Full Name ',
            codeDemand: ' Request code ',
            required_fullname: ' Full name is required ',
            required_codeDemand: ' Request code is required ',
            max_fullname: ' Your name must be 30 characters or less ',
            comment: ' Comment ',
            required_comment: ' Comment is required ',
            home: ' Home ',
            dashboard: ' Dashboard ',
            rdv: ' My appointments ',
            ticket: ' Create a ticket ',
            valider: ' Submit ',
            password_error: 'Please enter correct informations',
            credentiel: ' Please enter correct information ',
            email_error: ' The email has already been taken ',
            confirm_email_error: ' Please check your mail to confirm your count before login ',
            connexion_error: ' Make sure you are connected to internet ',
            required_firstname: ' Your firstname is required ',
            required_lastname: ' Your lastname is required ',
            required_gender: ' Gender is required ',
            required_birthdate: ' Your birthday is required ',
            required_birthcountry: ' Your birth country is required ',
            required_current_nationality: ' Your current nationality is required ',
            required_origine_nationality: ' Your origine nationality is required ',
            required_motif: ' Your reason for travel is required ',
            required_ordremission: ' Your mission order is required ',
            required_visatype: ' Your visa type is required ',
            required_nationality: ' Your nationality is required ',
            required_expiredate: ' The expiration date of your passport is required',
            required_passportnumber: 'Your passport number is required ',
            min_passportnumber: ' Your passport number must contain at least 06 characters ',
            max_passportnumber: ' Your passport number must not contain more than 09 characters ',
            caracter_passportnumber: ' Your passport number must contain only letters and numbers ',
            min_motif: ' Your travel reason must be at least 10 characters long ',
            min_ordremission: ' Your mision order must be at least 10 characters long ',
            required_copypassport: ' Your passport Copy  is required ',
            required_justificatiflogement: ' Your proof of accommodation is required ',
            justificatiflogement: ' Proof of accommodation ',
            pay_btn: ' Pay ',
            list_demand_title: ' List of requests ',
            file_required: ' Please upload only files of type: pdf, jpeg, jpg, svg ',
            required_phonenumber: ' Your phone number is required ',
            phonenumber: ' Phonenumber',
            welcome_word: ' Welcome on evisa Cameroun  ',
            email_notif: ' Your email is sent successfully ',
            en_cours: ' Pending ',
            approuve: ' Approved ',
            all: ' All ',
            visa_domiciliation: 'Domiciliation visa',
            visa_court_sejour: 'Short stay visa',
            visa_travail: 'Work visa',
            visa_transit: 'transit visa',
            temporary_visa: 'temporary visa',
            long_visa: 'long stay visa',
            tourist_visa: 'The tourist visa',
            number_day: 'Number of days',
            affaire_visa: "Case visa",
            confirm_count_text: ' Welcome to the e-visa Cameroon platform. To access your account, please confirm your email. Check your email and click on the account confirmation link. ',
            payment_confirm: ' Payment confirmed ',
            payment_pending: ' Payment in process of validation ',
            success_demand: ' Your request is well received ',
            click_link: ' Click on the link below to view the applications. ',
            requests: ' List of my requests ',
            caracter_firstname: ' The first name field must not contain any special characters ',
            caracter_lastname: ' The last name field must not contain any special characters ',
            faq: ' Frequently asked questions ',
            logout: 'Logout',
            delivert_at: 'Delivert at',
            valide_from: 'Valide from  ',
            valide_to: 'Valide at',
            reject_raison: 'Reject Raison',
            btn_reset: ' Reset ',
        },
        reverseLocale: {
            "Marié": "to_marry",
            "Veuve": "veuve",
            "Célibataire": "celibataire",
            "Célibataire san enfant": "celi_nokid",
            "Célibataire avec enfant": "celi_withkid",
            'Visa de court séjour': 'visa_court_sejour',
            'Visa de travail': 'visa_travail',
            'Visa de transit': 'visa_transit',
            'Visa temporaire': 'temporary_visa',
            'Visa de long séjour': 'long_visa',
            'Visa de tourisme': 'tourist_visa',
            'Visa affaire': 'affaire_visa'
        },
    },
})